/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.26.0
 * @since 1.24.0
 */

import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { makeSelectAuthoritiesIsServiceUser } from '@/main/pages/PageAuth/selectors/authSelectors';

import {
    makeSelectTranslationCommon,
    makeSelectUserNotificationsTranslation,
} from '../../internationalization/intSelectors';

export const useItemTooltipHints = () => {
    const notificationTranslation = useSelector(makeSelectUserNotificationsTranslation());
    const commonTranslation = useSelector(makeSelectTranslationCommon());
    const isServiceUser = useSelector(makeSelectAuthoritiesIsServiceUser());

    return useMemo(
        () => ({
            deleteHint: isServiceUser
                ? commonTranslation.serviceUser.tooltip
                : notificationTranslation.hints.deleteHint,
            viewItemHint: isServiceUser
                ? commonTranslation.serviceUser.tooltip
                : notificationTranslation.hints.viewHint,
            unviewItemHint: isServiceUser
                ? commonTranslation.serviceUser.tooltip
                : notificationTranslation.hints.unviewHint,
        }),
        [
            isServiceUser,
            commonTranslation.serviceUser.tooltip,
            notificationTranslation.hints.deleteHint,
            notificationTranslation.hints.viewHint,
            notificationTranslation.hints.unviewHint,
        ],
    );
};
